import React from 'react'
import styled from 'styled-components'

const SwapInput = styled.input<{
  exceed?: boolean
  right?: boolean
  small?: boolean
}>`
  text-align: ${({ right }) => (right ? 'right' : 'left')};
  color: ${({ theme, exceed }) =>
    exceed ? theme.balanceExceeded : theme.tradePanelInputTextColor};
  //    background-color: ${({ theme }) =>
    theme.tradeInputPanelBackgroundColor};
  background: none;
  font-family: Montserrat-Medium, Montserrat, serif;

  width: 250px;
  border: none;
  font-size: ${({ small }) => (small ? '2.25rem' : '3rem')};

  align-items: center;
  margin: 0.5rem;
  padding: 0em;
  selection: none;

  // Handling ellipsis
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-size: 3rem;

  &:hover {
    outline: none;
  }

  &:active {
    outline: none;
  }

  &:focus {
    outline: none;
  }

  &::placeholder {
  }

  /* Tablets */
  @media (max-width: 1400px) {
    padding: 0em;
  }

  /* Mobiles */
  @media (max-width: 640px) {
    font-size: 2.5rem;
    padding: 0em;
    width: 150px;
  }
`

export default SwapInput
